import _ from 'lodash';
import { CountrySlug, MarketSlug } from '../../../common/CountryMarketConfig';
import {
  FieldConfig,
  FieldConfigWithKey,
  StepConfig,
  StepConfigKey,
} from './types';

export const filterByCountryMarketSpecificDeps = <T extends StepConfigKey>(
  allOptions: StepConfig<T>,
  country?: CountrySlug,
  market?: MarketSlug,
  customFilter: (dep: unknown) => boolean = () => true,
): FieldConfigWithKey<T>[] => {
  return _.entries<FieldConfig>(allOptions)
    .map(([key, entry]) => ({
      key: key as T,
      ...entry,
    }))
    .filter((option) => {
      const applicationsByCountryAndMarket = _.entries(option.applications)
        .filter(([key]) => ['*', country].includes(key))
        .map(([, applicationByMarket]) => _.entries(applicationByMarket))
        .flat()
        .filter(([key]) => ['*', market].includes(key));

      if (applicationsByCountryAndMarket.length === 0) return false;

      const applicationDeps = applicationsByCountryAndMarket
        .map(([, applications]) => applications)
        .flat();

      if (applicationDeps.length === 0) return true;
      if (applicationDeps.includes('*')) return true;

      return applicationDeps.some(customFilter);
    });
};
